// Spec s11: exercise the whole pipeline with no LiveSwitch and no call.
//
// Reads a WAV (or anything decodeAudioData accepts), resamples it to 16 kHz via
// the same AudioContext the real source uses, and emits frames at wall-clock
// rate. Everything from s5 down runs unchanged, which is how extraction quality
// gets evaluated without booking a call.

import { BaseAudioSource, SAMPLE_RATE } from '../AudioSource';
import { MonoMixerGraph } from '../MonoMixerGraph';

export class FileAudioSource extends BaseAudioSource {
  private graph = new MonoMixerGraph();
  private node: AudioBufferSourceNode | null = null;
  private endedHandlers: Array<() => void> = [];

  constructor(private readonly file: Blob) {
    super();
  }

  onEnded(handler: () => void): void {
    this.endedHandlers.push(handler);
  }

  async start(): Promise<void> {
    await this.graph.start();
    this.graph.onFrame((pcm, timestampMs) => this.emitFrame(pcm, timestampMs));

    const bytes = await this.file.arrayBuffer();
    const decoded = await this.graph.context.decodeAudioData(bytes);

    const node = this.graph.createBufferSource();
    node.buffer = decoded;
    node.onended = () => this.endedHandlers.forEach((handler) => handler());
    node.start();
    this.node = node;
  }

  async stop(): Promise<void> {
    if (this.node) {
      this.node.onended = null;
      try {
        this.node.stop();
      } catch {
        /* already stopped */
      }
      this.node.disconnect();
      this.node = null;
    }
    await this.graph.stop();
  }
}

export { SAMPLE_RATE };
